import React from "react";
import styled from "styled-components";
import NavBarItem from "../navBarItem/NavBarItem";
import settingsPages from "../utils/settingsPages";

export interface ILeftMenu {
  selectedSettingsPage: string;
  setSelectedSettingsPage: React.Dispatch<React.SetStateAction<string>>;
}

const NavBarContainer = styled.div`
  width: 20%;
  height: 100%;

  @media screen and (max-width: 850px) {
    display: none;
  }
`;

const NavBarContent = styled.ul`
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  height: 100%;
  width: 100%;
`;

const LeftMenu: React.FC<ILeftMenu> = ({
  selectedSettingsPage,
  setSelectedSettingsPage,
}) => {
  return (
    <NavBarContainer>
      <NavBarContent>
        {settingsPages.map((settingsPage) => {
          return (
            <NavBarItem
              key={settingsPage.value}
              settingsPage={settingsPage}
              selectedSettingsPage={selectedSettingsPage}
              setSelectedSettingsPage={setSelectedSettingsPage}
            />
          );
        })}
      </NavBarContent>
    </NavBarContainer>
  );
};

export default LeftMenu;
